<mat-accordion>
  <mat-expansion-panel [(expanded)]="expanded" class="config-panel">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <h3>Topbar filters configuration</h3>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <form [formGroup]="form">
      <div class="wrap">
        <div class="item">
          <mat-checkbox formControlName="show">Show topbar</mat-checkbox>
        </div>
        <div class="item">
          @if (form.get('show').value) {
            <mat-checkbox class="item" formControlName="showChips"
              >
              Show filter chips
            </mat-checkbox>
          }
        </div>
      </div>
      @if (form.get('show').value) {
        <services-filter-configuration [parentFormGroup]="form"
          [servicesFilterConfig]="sectionConfig.topbarFiltersConfig?.servicesFilterConfig ?? null">
        </services-filter-configuration>
      }
    </form>
  </mat-expansion-panel>
</mat-accordion>
